var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"observation-description-plot"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":"info"}}),_vm._l((_vm.text),function(t,i){return _c('span',{key:i,staticStyle:{"display":"block"}},[_vm._v(_vm._s(t))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }